export default __webpack_public_path__ + "static/media/Tiktok.4b664d44.png";